module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out-cont"
  }, [_c('div', {
    staticClass: "fake-header",
    staticStyle: {
      "height": "80px",
      "width": "100%",
      "background": "#218BEF"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "guide"
  }, [_c('div', {
    staticClass: "guide-title"
  }, [_vm._v("请选择办事情形")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "guide-btn",
    on: {
      "click": function($event) {
        return _vm.openNewPage('https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440102008001')
      }
    }
  }, [_vm._v("生成您的专属办事指南")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide-header"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/intelligent/robort.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chinese-title"
  }, [_vm._v("业务办理智能引导")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide-wrap"
  }, [_c('div', {
    staticClass: "guide-item"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-cont"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("1.请选择培训机构营利类型：")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("非营利性培训机构")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("营利性培训机构")])])])]), _vm._v(" "), _c('div', {
    staticClass: "guide-item"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-cont"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("2.请选择举办者类型：")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("社会组织")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("个人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "guide-item"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-cont"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("3.请选择办学场所类型")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("自有场所举办")]), _vm._v(" "), _c('div', {
    staticClass: "rominfo"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("已办理房屋产权证\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("未办理房屋产权证\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "guide-item"
  }, [_c('div', {
    staticClass: "guide-icon guide-icon-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-cont"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("4.请问是否有在线培训业务？")]), _vm._v(" "), _c('div', {
    staticClass: "rominfo"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("是\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "handleTypeOptions",
      "checked": ""
    }
  }), _vm._v("否\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "guide-item"
  }, [_c('div', {
    staticClass: "guide-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-line-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-cont"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("5.请选择办学形式")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("联合办学（两个以上举办者联合举办）")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("单独举办")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ecae0f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Intelligent.vue
// module id = 1141
// module chunks = 0